import { render } from "./Views.vue?vue&type=template&id=6e4e4b33&ts=true"
import script from "./Views.vue?vue&type=script&lang=ts"
export * from "./Views.vue?vue&type=script&lang=ts"

import "./Views.vue?vue&type=style&index=0&id=6e4e4b33&lang=scss"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__